import { render } from "./SwiperNavBtn.vue?vue&type=template&id=5dcd968e&ts=true"
import script from "./SwiperNavBtn.vue?vue&type=script&lang=ts"
export * from "./SwiperNavBtn.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__